import React from 'react';
import InputField from 'components/pure/utils/form/InputField';
import classNames from 'classnames';

export default class WeightingInput extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);

    this.state = {
      shouldShowZero: false,
    };
  }

  onChange(v) {
    this.setState({shouldShowZero: v === 0});

    this.props.onChange(v);
  }

  onBlur(v) {
    this.setState({shouldShowZero: true});
    this.props.onBlur(v);
  }

  onFocus() {
    this.setState({shouldShowZero: false});
  }

  render() {
    const {wrapperClass, inputKey, val, autoFocus, blink} = this.props;

    const {shouldShowZero} = this.state;

    const justBlinked = blink && Math.abs(new Date() - blink) < 500;

    let userFriendlyVal = val;
    if (val === 0 && !shouldShowZero && !justBlinked) {
      userFriendlyVal = '';
    }

    return (
      <div className={wrapperClass}>
        <InputField
          key={inputKey}
          ref={ref => (this.ref = ref)}
          type="number"
          min={0}
          max={100}
          value={userFriendlyVal}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          inputClassName={classNames(['field-input', blink && 'blink'])}
          autoFocus={autoFocus}
        />
      </div>
    );
  }
}
